export interface IRestaurantEntitlementLike {
  paidTier?: unknown;
  planExpiresAt?: unknown;
}

export function parseDateSafe(value: unknown): Date | null {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  return null;
}

export function isPlanExpired(planExpiresAt: unknown, nowMs: number = Date.now()): boolean {
  const d = parseDateSafe(planExpiresAt);
  if (!d) return false;
  return d.getTime() <= nowMs;
}

export function getPurchasedTier(restaurant: IRestaurantEntitlementLike | null | undefined): number {
  const tierNum = Number(restaurant?.paidTier ?? 0);
  const tier = Number.isFinite(tierNum) ? Math.floor(tierNum) : 0;
  return tier > 0 ? tier : 0;
}

export function getEffectiveTier(
  restaurant: IRestaurantEntitlementLike | null | undefined,
  nowMs: number = Date.now(),
): number {
  const tier = getPurchasedTier(restaurant);
  if (tier <= 0) return 0;

  return isPlanExpired(restaurant?.planExpiresAt, nowMs) ? 0 : tier;
}

